import styled from "styled-components"

const Wrapper = styled.section`
  max-width: 1300px;
  padding: 0 20px;
  margin: 0 auto;
`

export default Wrapper
